import { useState, useEffect, useRef } from "react";

const categories = [
  { name: "Shoes", url: "https://kaspreadsheet.com/category-911-Shoes.html" },
  { name: "Hoodies/Sweaters", url: "https://kaspreadsheet.com/search-912/name/Shoes.html" },
  { name: "T-Shirts", url: "https://kaspreadsheet.com/search-913/name/Shoes.html" },
  { name: "Jackets", url: "https://kaspreadsheet.com/search-914/name/Shoes.html" },
  { name: "Pants/Shorts", url: "https://kaspreadsheet.com/search-915/name/Shoes.html" },
  { name: "Headwear", url: "https://kaspreadsheet.com/search-916/name/Shoes.html" },
  { name: "Sets", url: "https://kaspreadsheet.com/search-917/name/Shoes.html" },
  { name: "underwear/underpants", url: "https://kaspreadsheet.com/search-918/name/Shoes.html" },
  { name: "Jersey", url: "https://kaspreadsheet.com/search-919/name/Shoes.html" },
  { name: "Accessories", url: "https://kaspreadsheet.com/search-920/name/Shoes.html" },
  { name: "Bags", url: "https://kaspreadsheet.com/search-921/name/Shoes.html" },
  { name: "Belts", url: "https://kaspreadsheet.com/search-922/name/Shoes.html" },
  { name: "Perfumes", url: "https://kaspreadsheet.com/search-923/name/Shoes.html" },
  { name: "Other Stuff", url: "https://kaspreadsheet.com/search-924/name/Shoes.html" },
];

export default function CategorySection() {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState<string | null>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (cat: { name: string; url: string }) => {
    setSelected(cat.name);
    setIsOpen(false);
    window.open(cat.url, "_blank", "noopener,nofollow");
  };

  return (
    <section className="py-10 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-8 max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
          Категории товаров
        </h2>
        <p className="text-foreground-600 mb-8">
          Выберите категорию и перейдите к покупкам на основной платформе
        </p>

        <div className="relative mb-8" ref={dropdownRef}>
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="w-full md:w-80 flex items-center justify-between bg-white border border-background-200 rounded-lg px-4 py-3 text-foreground-800 hover:border-primary-400 transition-colors"
          >
            <span>{selected || "Выберите категорию"}</span>
            <div className="w-5 h-5 flex items-center justify-center">
                <i className={isOpen ? "ri-arrow-up-s-line text-foreground-500" : "ri-arrow-down-s-line text-foreground-500"} />
              </div>
          </button>

          {isOpen && (
            <div className="absolute top-full left-0 right-0 md:right-auto md:w-80 mt-2 bg-white border border-background-200 rounded-lg z-30 max-h-72 overflow-y-auto">
              {categories.map((cat) => (
                <button
                  key={cat.name}
                  onClick={() => handleSelect(cat)}
                  className="w-full text-left px-4 py-3 text-sm text-foreground-800 hover:bg-background-100 border-b border-background-100 last:border-0 transition-colors"
                >
                  {cat.name}
                </button>
              ))}
            </div>
          )}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center justify-center bg-white border border-background-200 rounded-lg px-4 py-4 text-sm font-medium text-foreground-800 hover:border-primary-400 hover:text-primary-600 transition-colors text-center whitespace-nowrap"
            >
              {cat.name}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}